import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { TopBar } from './components/TopBar';
import { Navbar } from './components/Navbar';
import { LanguageBar } from './components/LanguageBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { About } from './components/About';
import { ProofCarousel } from './components/ProofCarousel';
import { Testimonials } from './components/Testimonials';
import { ServiceAreas } from './components/ServiceAreas';
import { FAQ } from './components/FAQ';
import { QuoteForm } from './components/QuoteForm';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { CookiesPage } from './pages/CookiesPage';
import { AdaPage } from './pages/AdaPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function HomePage({
  language
}: {
  language: 'en' | 'es';
}) {
  return <main data-id="element-0">
      <Hero language={language} data-id="element-1" />
      <SocialProof language={language} data-id="element-2" />
      <Services language={language} data-id="element-3" />
      <HowItWorks language={language} data-id="element-4" />
      <About language={language} data-id="element-5" />
      <ProofCarousel language={language} data-id="element-6" />
      <Testimonials language={language} data-id="element-7" />
      <ServiceAreas language={language} data-id="element-8" />
      <FAQ language={language} data-id="element-9" />
      <QuoteForm language={language} data-id="element-10" />
      <FinalCTA language={language} data-id="element-11" />
    </main>;
}
function getInitialLanguage(): 'en' | 'es' {
  const saved = localStorage.getItem('userSelectedLanguage');
  if (saved === 'en' || saved === 'es') return saved;
  const browser = navigator.language || (navigator as any).userLanguage || 'en';
  return browser.startsWith('es') ? 'es' : 'en';
}
export function App() {
  const [language, setLanguage] = useState<'en' | 'es'>(getInitialLanguage);
  const changeLanguage = (newLang: 'en' | 'es') => {
    setLanguage(newLang);
    localStorage.setItem('userSelectedLanguage', newLang);
  };
  return <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-obsidian text-warmWhite font-inter selection:bg-gold selection:text-black" data-id="element-12">
      <ScrollToTop data-id="element-13" />
      <TopBar language={language} data-id="element-14" />
      <Navbar language={language} data-id="element-15" />
      <LanguageBar language={language} onLanguageChange={changeLanguage} data-id="element-16" />
      <Routes data-id="element-17">
        <Route path="/" element={<HomePage language={language} data-id="element-19" />} data-id="element-18" />
        <Route path="/privacy" element={<PrivacyPage language={language} data-id="element-21" />} data-id="element-20" />
        <Route path="/terms" element={<TermsPage language={language} data-id="element-23" />} data-id="element-22" />
        <Route path="/cookies" element={<CookiesPage language={language} data-id="element-25" />} data-id="element-24" />
        <Route path="/ada" element={<AdaPage language={language} data-id="element-27" />} data-id="element-26" />
      </Routes>
      <Footer language={language} data-id="element-28" />
    </div>;
}